export const models = [
    {
        name: 'contact_managment',
        text: 'Khách hàng',
        permissions: [],
        level: 1,
    },
    {
        name: 'contact',
        text: 'Thông tin khách hàng',
        permissions: ['read', 'create', 'update', 'delete', 'view_all', 'download'],
        level: 2,
    },
    {
        name: 'contact_change_user',
        text: 'Chuyển người phụ trách',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'contact_change_status',
        text: 'Chuyển mối quan hệ',
        permissions: ['read'],
        level: 2,
    },
    // {
    //     name: 'check_store_g',
    //     text: 'Kho G',
    //     permissions: ['read'],
    //     level: 2,
    // },
    // {
    //     name: 'contact_change_phone',
    //     text: 'Chuyển số điện thoại',
    //     permissions: ['read'],
    //     level: 2,
    // },
    // {
    //     name: 'contact_move_to_cc',
    //     text: 'Thu hồi contact về kho CC',
    //     permissions: ['read'],
    //     level: 2,
    // },
    // {
    //     name: 'contact_move_to_m',
    //     text: 'Thu hồi contact về kho M',
    //     permissions: ['read'],
    //     level: 2,
    // },
    // {
    //     name: 'contact_change_store',
    //     text: 'Chuyển kho',
    //     permissions: ['read'],
    //     level: 2,
    // },
    // {
    //     name: 'contact_change_school_level',
    //     text: 'Chuyển ngành',
    //     permissions: ['read'],
    //     level: 2,
    // },
    {
        name: 'contact_change_store',
        text: 'Chuyển kho',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'search_all',
        text: 'Tìm kiếm tất cả',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'merge-contact',
        text: 'Gộp contact',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'admin-search',
        text: 'Tìm kiếm cấp admin',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'hide-contact-log',
        text: 'Ẩn log ghi chú',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'lock-edit-attr-dashboard',
        text: 'Khóa edit thông tin trực tiếp trên dashboard',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'export-full-contact',
        text: 'Download thông tin khách hàng full',
        permissions: ['read'],
        level: 2,
    },
    // {
    //     name: 'export-full-contact',
    //     text: 'Download thông tin khách hàng full',
    //     permissions: ['download'],
    //     level: 2,
    // },
    {
        name: 'take-care-contact',
        text: 'Chăm sóc contact',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'change-contact-agency',
        text: 'Chuyển kho Thường / Đại lý',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'change-bot-call',
        text: 'Tạo chiến dịch BOT CALL',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'user_managment',
        text: 'Quản lý người dùng',
        permissions: [],
        level: 1,
    },
    {
        name: 'user',
        text: 'Người dùng',
        permissions: ['read', 'create', 'update', 'delete', 'view_all'],
        level: 2,
    },
    {
        name: 'department',
        text: 'Phòng ban',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'kpi',
        text: 'KPI',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'schedule',
        text: 'Lịch làm việc',
        permissions: ['read', 'create', 'update', 'delete', 'view_all'],
        level: 2,
    },
    {
        name: 'appointment',
        text: 'Lịch hẹn',
        permissions: ['read', 'create', 'update', 'delete', 'view_all'],
        level: 2,
    },
    {
        name: 'product_management',
        text: 'Quản lý sản phẩm',
        permissions: [],
        level: 1,
    },
    {
        name: 'product',
        text: 'Sản phẩm',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'product_group',
        text: 'Nhóm sản phẩm',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'combo',
        text: 'Combo',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'call_center_management',
        text: 'Call Center',
        permissions: [],
        level: 1,
    },
    {
        name: 'call_center',
        text: 'Danh sách cuộc gọi',
        permissions: ['read', 'view_all'],
        level: 2,
    },
    {
        name: 'general-call-center-report',
        text: 'Báo cáo chung',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'employee-call-center-report',
        text: 'Báo cáo nhân viên',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'download-call-center-record',
        text: 'Ghi âm',
        permissions: ['read', 'download'],
        level: 2,
    },
    {
        name: 'auto-call',
        text: 'Auto call',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'order_management',
        text: 'Đơn hàng',
        permissions: [],
        level: 1,
    },
    {
        name: 'order',
        text: 'Đơn hàng',
        permissions: ['read', 'create', 'update', 'delete', 'download', 'view_all'],
        level: 2,
    },
    {
        name: 'back-order-old',
        text: 'Quay về luồng đơn cũ ( V1 )',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'order-ctv-create',
        text: 'CTV tạo đơn',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'order-contact',
        text: 'Xem tài khoản',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'order-payment',
        text: 'Xác nhận thanh toán',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'every-order',
        text: 'Sửa mọi đơn hàng',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'export-order-accountant',
        text: 'Export kế toán',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'report',
        text: 'Báo cáo',
        permissions: [],
        level: 1,
    },
    {
        name: 'general-report',
        text: 'Báo cáo chung',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'account-report',
        text: 'Báo cáo tài khoản',
        permissions: ['read', 'download'],
        level: 2,
    },
    {
        name: 'module-report',
        text: 'Báo cáo module',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'department-report',
        text: 'Báo cáo phòng ban',
        permissions: [],
        level: 2,
    },
    {
        name: 'result-report',
        text: 'Theo kết quả',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'employee-report',
        text: 'Theo nhân viên',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'status-report',
        text: 'Theo trạng thái',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'contact-source-report',
        text: 'Theo nguồn contact',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'human-resources-report',
        text: 'Theo nguồn lực',
        permissions: ['read', , 'download'],
        level: 3,
    },
    {
        name: 'view-total-report',
        text: 'View tổng',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'best-employee',
        text: 'Báo cáo nhân viên xuất sắc',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'sale-leader',
        text: 'Báo cáo trưởng nhóm',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'revenue-report',
        text: 'Báo cáo doanh thu',
        permissions: [],
        level: 2,
    },
    {
        name: 'product-group-revenue-report',
        text: 'Theo sản phẩm, nhóm sản phẩm',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'customer-revenue-report',
        text: 'Theo khách hàng',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'personal-report',
        text: 'Báo cáo thành tích cá nhân',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'delivery-report',
        text: 'Báo cáo giao hàng',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'partner',
        text: 'Đối tác',
        permissions: [],
        level: 1,
    },
    {
        name: 'dashboard',
        text: 'Dashboard Partner',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'a-department-report',
        text: 'Báo cáo phòng ban trực thuộc',
        permissions: [],
        level: 2,
    },
    {
        name: 'employee-report-a-department',
        text: 'Theo nhân viên',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'dashboard-partner',
        text: 'Dashboard CTV',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'partner-report',
        text: 'Báo cáo CTV',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'partner-policy',
        text: 'Chính sách CTV',
        permissions: ['read', 'update'],
        level: 2,
    },
    {
        name: 'marketing-report',
        text: 'Marketing',
        permissions: [],
        level: 1,
    },
    {
        name: 'marketer-report',
        text: 'Báo cáo marketer',
        permissions: ['read', 'view_all'],
        level: 2,
    },
    // {
    //     name: 'marketing-report-by-marketer',
    //     text: 'Theo Tiểu học',
    //     permissions: ['read'],
    //     level: 3,
    // },
    // {
    //     name: 'marketing-report-by-marketer-thpt',
    //     text: 'Theo THPT',
    //     permissions: ['read'],
    //     level: 3,
    // },
    // {
    //     name: 'marketing-report-by-marketer-thcs',
    //     text: 'Theo THCS',
    //     permissions: ['read'],
    //     level: 3,
    // },
    {
        name: 'marketing-report-by-content',
        text: 'Báo cáo content',
        permissions: ['read', 'view_all'],
        level: 2,
    },
    {
        name: 'contact-register',
        text: 'Báo cáo đăng ký theo ngày',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'performance-mkt',
        text: 'Báo cáo messenger',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'performancep-mkt-detail',
        text: 'Xem chi tiết data',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'short-link',
        text: 'Short link',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'define-master-content',
        text: 'Khai báo mã content',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'data_setting_management',
        text: 'Cài đặt dữ liệu',
        permissions: [],
        level: 1,
    },
    {
        name: 'contact-setting',
        text: 'Khách hàng',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'contact-source',
        text: 'Nguồn khách hàng',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'contact-status',
        text: 'Mối quan hệ',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    // {
    //     name: 'role',
    //     text: 'Nhóm quyền',
    //     permissions: ['read', 'create', 'update', 'delete'],
    //     level: 2,
    // },
    {
        name: 'announcement',
        text: 'Thông báo',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'school-level',
        text: 'Nhóm ngành',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'store-management',
        text: 'Quản lý kho',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2,
    },
    {
        name: 'priority-setting',
        text: 'Cấu hình độ ưu tiên',
        permissions: ['read', 'update'],
        level: 2,
    },
    {
        name: 'keep-contact-setting',
        text: 'Cấu hình giữ contact',
        permissions: ['read', 'update'],
        level: 2,
    },
    {
        name: 'setting',
        text: 'Cấu hình phân bổ',
        permissions: [],
        level: 1,
    },
    {
        name: 'allotment-contact',
        text: 'Lộ trình phân bổ',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 2
    },
    {
        name: 'setting-contact',
        text: 'Cấu hình phân bổ',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'contact-advise',
        text: 'Nhận contact tư vấn',
        permissions: ['read'],
        level: 2
    },
    // {
    //     name: 'dashboard_management',
    //     text: 'Dashboard',
    //     permissions: [],
    //     level: 1,
    // },
    // {
    //     name: 'dashboard',
    //     text: 'Dashboard',
    //     permissions: ['read'],
    //     level: 2,
    // },
    {
        name: 'sms',
        text: 'Sms',
        permissions: [],
        level: 1,
    },
    {
        name: 'mkt-sms',
        text: 'Marketing SMS',
        permissions: [],
        level: 2,
    },
    {
        name: 'mkt-sms-message',
        text: 'Tin nhắn',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 3,
    },
    {
        name: 'mkt-sms-customer',
        text: 'Tệp khách hàng',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 3,
    },
    {
        name: 'mkt-sms-contact',
        text: 'Xem danh sách contact của tệp',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'mkt-sms-message-history',
        text: 'Lịch sử gửi tin',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'document-training',
        text: 'Tài liệu',
        permissions: [],
        level: 1,
    },
    {
        name: 'training-sale',
        text: 'Training sale',
        permissions: ['read', 'update', 'create', 'delete', 'download'],
        level: 2,
    },
    {
        name: 'training-manager',
        text: 'Training manager',
        permissions: ['read', 'update', 'create', 'delete', 'download'],
        level: 2,
    },
    {
        name: 'setting-new',
        text: 'Cài đặt tổ chức',
        permissions: [],
        level: 1,
    },
    {
        name: 'setting-organization',
        text: 'Tổ chức bộ máy',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 2,
    },
    {
        name: 'setting-role',
        text: 'Cơ cấu nhóm quyền',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 2,
    },
    {
        name: 'setting-rank',
        text: 'Quản lý lộ trình làm việc',
        permissions: ['read', 'update'],
        level: 2,
    },
    {
        name: 'setting-kpi',
        text: 'Quản lý bộ chỉ số KPI',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 2,
    },
    {
        name: 'change-module-contact',
        text: 'Chuyển vị trí',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'tutor-test',
        text: 'Vận hành gia sư',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'view-store-new-contact',
        text: 'Xem kho số mới',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'social-account',
        text: 'Tài khoản social',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'tutoring-test',
        text: 'Vận hành test đầu vào',
        permissions: [],
        level: 1,
    },
    {
        name: 'test_schedule_overview',
        text: 'Tổng quan lịch test',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'operator',
        text: 'Tác nghiệp vận hành',
        permissions: [],
        level: 2
    },
    {
        name: 'operator_tutor_online',
        text: 'Tutor online',
        permissions: ['read', 'update', 'create', 'delete', 'download', 'view_all'],
        level: 3,
    },
    {
        name: 'tutor_change_operator_online',
        text: 'Chuyển vận hành ',
        permissions: ['read'],
        level: 4,
    },
    {
        name: 'tutor_change_status_online',
        text: 'Chuyển trạng thái VH',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'ieltsy',
        text: 'IELTSY',
        permissions: ['read', 'update', 'create', 'delete', 'download', 'view_all'],
        level: 3,
    },
    {
        name: 'tutor_change_operator_ieltsy',
        text: 'Chuyển vận hành ',
        permissions: ['read'],
        level: 4,
    },
    {
        name: 'tutor_change_status_ieltsy',
        text: 'Chuyển trạng thái VH',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'interviewer',
        text: 'Tác nghiệp chuyên môn',
        permissions: [],
        level: 2
    },
    {
        name: 'interviewer_tutor_online',
        text: 'Tutor online',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 3,
    },
    {
        name: 'tutor_change_tester_online',
        text: 'Chuyển tester',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'interviewer_tutor_ieltsy',
        text: 'IELTSY',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 3,
    },
    {
        name: 'tutor_change_tester_ieltsy',
        text: 'Chuyển tester',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'tutor_test_shift',
        text: 'Tạo ca test',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 2
    },
    {
        name: 'tutor_test_schedule',
        text: 'Lịch làm việc test',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 2
    },
    {
        name: 'tutor_change_all_status',
        text: 'Sửa trạng thái cuối',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'tutoring-test-report',
        text: 'Báo cáo',
        permissions: ['read', 'download'],
        level: 2
    },
    {
        name: 'tutoring-test-interviewer',
        text: 'Người phỏng vấn',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'tutoring-test-list-trail',
        text: 'Danh sách học thử',
        permissions: ['read','update'],
        level: 2
    },
    {
        name: 'tutoring-test-filter-school-type',
        text: 'Lọc phân loại trường',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'bitu-chat',
        text: 'Bitu chat',
        permissions: [],
        level: 1,
    },
    // {
    //     name: 'bitu-chat-advise',
    //     text: 'Tư vấn Bitu chat',
    //     permissions: ['read'],
    //     level: 2
    // },
    {
        name: 'bitu-chat-admin',
        text: 'Bitalk: Quản trị fanpage, nhãn, khác',
        permissions: ['read', 'create', 'update', 'delete' ],
        level: 2
    },
    {
        name: 'bitu-chat-advise',
        text: 'Bitalk: Tư vấn',
        permissions: ['read', 'create', 'update', 'delete', 'view_all'],
        level: 2
    },
    {
        name: 'bitu-chat-advise-divide-shift',
        text: 'Phân ca',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'bitu-chat-customer',
        text: 'Bitalk: Danh sách khách hàng',
        permissions: ['read', 'view_all'],
        level: 2
    },
    {
        name: 'bitu-shift-management',
        text: 'Bitalk: Quản lý ca',
        permissions: ['read', 'create', 'update', 'delete'],
        level: 2
    },
    {
        name: 'bitu-schedule-management',
        text: 'Bitalk: Quản lý lịch làm việc',
        permissions: ['read', 'create', 'delete', 'view_all'],
        level: 2
    },
    {
        name: 'agency-active-code',
        text: 'Mã kích hoạt đại lý',
        permissions: [],
        level: 1,
    },
    {
        name: 'agency-user',
        text: 'Nhân viên kinh doanh',
        permissions: ['read', 'create'],
        level: 2
    },
    {
        name: 'agency-admin',
        text: 'Admin đại lý',
        permissions: ['read', 'update', 'create', 'download'],
        level: 2
    },
     {
        name: 'teacher',
        text: 'Giáo viên',
        permissions: [],
        level: 1,
    },
     {
        name: 'tutor-teacher',
        text: 'Giáo viên',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'sort-calendar',
        text: 'Quản lý lịch dạy giáo viên',
        permissions: ['read', 'update', 'download', 'view_all'],
        level: 2
    },
    {
        name: 'sort-teachers',
        text: 'Quản lý giáo viên',
        permissions: ['read', 'create', 'update', 'view_all'],
        level: 2
    },
    {
        name: 'teacher-manager-info',
        text: 'Thông tin cơ bản',
        permissions: ['read', 'update'],
        level: 3
    },
    {
        name: 'teacher-manager-teaching',
        text: 'Thông tin giảng dạy',
        permissions: ['read', 'update'],
        level: 3
    },
    {
        name: 'program-teaching',
        text: 'Chương trình giảng dạy',
        permissions: ['read', 'update'],
        level: 3
    },
    {
        name: 'teaching-off',
        text: 'Thông tin nghỉ việc',
        permissions: ['read', 'update'],
        level: 3
    },
    {
        name: 'rate-salary',
        text: 'Thông tin rate lương',
        permissions: ['read', 'update'],
        level: 3
    },
    {
        name: 'teach-register',
        text: 'Đăng ký giảng dạy',
        permissions: ['read', 'update'],
        level: 3
    },
    {
        name: 'teacher-care',
        text: 'Chăm sóc giáo viên',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'teacher-work-sheet',
        text: 'Bảng công / Bảng phạt giáo viên',
        permissions: ['read', 'create',  'update'],
        level: 2
    },
    {
        name: 'teacher-salary',
        text: 'Tính lương giáo viên',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'care',
        text: 'TUTOR CARE - GIA SƯ TIỂU HỌC',
        permissions: [],
        level: 1,
    },
    {
        name: '',
        text: 'Vai trò',
        permissions: [],
        level: 2,
    },
    {
        name: 'tutor-homeroom-teacher',
        text: 'Quản lý lớp',
        permissions: ['read'],
        level: 3
    },
     {
        name: 'care-sale',
        text: 'Sale gia hạn',
        permissions: ['read'],
        level: 3
    },
    // {
    //     name: 'c0-tab',
    //     text: 'TA0',
    //     permissions: ['read', 'view_all'],
    //     level: 3,
    // },
    {
        name: 'periodic-tab',
        text: 'Tab chăm sóc định kỳ',
        permissions: ['read', 'view_all'],
        level: 2,
    },
    {
        name: 'periodic-tab-change-early-extend',
        text: 'Chuyển gia hạn sớm',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'periodic-tab-change-extend-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'extends-tab',
        text: 'Tab gia hạn',
        permissions: ['read', 'view_all'],
        level: 2,
    },
    {
        name: 'extends-tab-change-extend-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'move-sale-tab',
        text: 'Tab chuyển sale',
        permissions: ['read', 'view_all'],
        level: 2,
    },
    {
        name: 'move-sale-tab-change-extend-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 3,
    },
    // {
    //     name: 'all-tab',
    //     text: 'Tất cả',
    //     permissions: ['read', 'view_all'],
    //     level: 3,
    // },
    {
        name: 'special-care-tutor',
        text: 'Tab chăm sóc đặc biệt',
        permissions: [],
        level: 2
    },
    {
        name: 'special-care-tutor-student',
        text: 'Học sinh chăm sóc đặc biệt',
        permissions: ['read', 'view_all'],
        level: 3
    },
    {
        name: 'tutor-task-tab',
        text: 'Tab công việc',
        permissions: ['read', 'view_all'],
        level: 2
    },
    {
        name: 'create-task-tutor',
        text: 'Tạo/sửa công việc',
        permissions: ['read', 'create', 'update'],
        level: 3
    },
    {
        name: 'tutor-student-detail',
        text: 'Thông tin chi tiết học viên',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'on-leave-and-reserve',
        text: 'Nghỉ phép/Bảo lưu/Đi học lại',
        permissions: ['read', 'create'],
        level: 3
    },
    {
        name: 'tutor-student-detail-change-sale',
        text: 'Chuyển sale',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'care-call',
        text: 'Cấu hình cuộc gọi tutoring online',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'search-all-tutor',
        text: 'Tìm kiếm tất cả bản ghi tutor',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'tutor-care-change-class-manager',
        text: 'Chuyển quản lý lớp',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'tutor-care-change-class-manager-limitation',
        text: 'Chuyển quản lý lớp GIỚI HẠN',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'care',
        text: 'TUTOR CARE - GIA SƯ THCS',
        permissions: [],
        level: 1,
    },
    {
        name: '',
        text: 'Vai trò',
        permissions: [],
        level: 2,
    },
    {
        name: 'tutor-homeroom-teacher-secondary',
        text: 'Quản lý lớp',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'care-sale-secondary',
        text: 'Sale gia hạn',
        permissions: ['read'],
        level: 3
    },
    // {
    //     name: 'c0-tab',
    //     text: 'TA0',
    //     permissions: ['read', 'view_all'],
    //     level: 3,
    // },
    {
        name: 'periodic-tab-secondary',
        text: 'Tab chăm sóc định kỳ',
        permissions: ['read', 'view_all'],
        level: 2,
    },
    {
        name: 'periodic-tab-secondary-change-class-manager',
        text: 'Chuyển quản lý lớp',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'periodic-tab-secondary-change-early-extend',
        text: 'Chuyển gia hạn sớm',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'periodic-tab-secondary-change-extend-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'extends-tab-secondary',
        text: 'Tab gia hạn',
        permissions: ['read', 'view_all'],
        level: 2,
    },
    {
        name: 'extends-tab-secondary-change-class-manager',
        text: 'Chuyển quản lý lớp',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'extends-tab-secondary-change-extend-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'move-sale-tab-secondary',
        text: 'Tab chuyển sale',
        permissions: ['read', 'view_all'],
        level: 2,
    },
    {
        name: 'move-sale-tab-secondary-change-class-manager',
        text: 'Chuyển quản lý lớp',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'move-sale-tab-secondary-change-extend-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 3,
    },
    // {
    //     name: 'all-tab',
    //     text: 'Tất cả',
    //     permissions: ['read', 'view_all'],
    //     level: 3,
    // },
    {
        name: 'special-care-tutor-secondary',
        text: 'Tab chăm sóc đặc biệt',
        permissions: [],
        level: 2
    },
    {
        name: 'special-care-tutor-student-secondary',
        text: 'Học sinh chăm sóc đặc biệt',
        permissions: ['read', 'view_all'],
        level: 3
    },
    {
        name: 'tutor-task-tab-secondary',
        text: 'Tab công việc',
        permissions: ['read', 'view_all'],
        level: 2
    },
    {
        name: 'create-task-tutor-secondary',
        text: 'Tạo/sửa công việc',
        permissions: ['read', 'create', 'update'],
        level: 3
    },
    {
        name: 'tutor-student-detail-secondary',
        text: 'Thông tin chi tiết học viên',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'on-leave-and-reserve-secondary',
        text: 'Nghỉ phép/Bảo lưu/Đi học lại',
        permissions: ['read', 'create'],
        level: 3
    },
    {
        name: 'tutor-student-detail-secondary-change-sale',
        text: 'Chuyển sale',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'tutor-student-detail-secondary-change-homeroom-teacher',
        text: 'Chuyển quản lý lớp',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'care-call-secondary',
        text: 'Cấu hình cuộc gọi tutoring online',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'search-all-tutor-secondary',
        text: 'Tìm kiếm tất cả bản ghi tutor',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'care-duo',
        text: 'CUSTOMER CARE DUO',
        permissions: [],
        level: 1,
    },
    {
        name: 'setting',
        text: 'Cài đặt cấu hình',
        permissions: [],
        level: 2
    },
    {
        name: 'periodic-care',
        text: 'Chăm sóc định kì',
        permissions: ['read', 'create', 'update'],
        level: 3
    },
    {
        name: 'extend',
        text: 'Gia hạn',
        permissions: ['read', 'create', 'update'],
        level: 3
    },
    {
        name: 'list',
        text: 'Màn hình danh sách',
        permissions: [],
        level: 2
    },
    {
        name: 'periodic-care-tab',
        text: 'Tab chăm sóc định kì',
        permissions: ['read', 'view_all'],
        level: 3
    },
    {
        name: 'periodic-care-tab-early-extend',
        text: 'Gia hạn sớm',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'periodic-care-tab-change-teacher',
        text: 'Chuyển quản lý học tập',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'periodic-care-tab-move-to-general',
        text: 'Chuyển vào kho chung',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'extend-tab',
        text: 'Tab Gia hạn',
        permissions: ['read', 'view_all'],
        level: 3
    },
    {
        name: 'extend-tab-early-extend',
        text: 'Gian hạn sớm',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'extend-tab-change-teacher',
        text: 'Chuyển quản lý học tập',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'general-tab',
        text: 'Tab kho chung',
        permissions: ['read', 'view_all'],
        level: 3
    },
    {
        name: 'general-tab-move-to-periodic-care',
        text: 'Chuyển sang chăm sóc định kì',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'general-tab-change-teacher',
        text: 'Chuyển quản lý học tập',
        permissions: ['read'],
        level: 4
    },
    {
        name: 'student-info',
        text: 'Thông tin chi tiết học viên',
        permissions: [],
        level: 2
    },
    {
        name: 'student-periodic-care-tab',
        text: 'Tab chăm sóc định kì',
        permissions: ['read', 'update'],
        level: 3
    },
    {
        name: 'student-extend-tab',
        text: 'Tab Gia hạn',
        permissions: ['read', 'update'],
        level: 3
    },
    {
        name: 'student-detail',
        text: 'Thông tin học viên',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'care-duo-position',
        text: 'Vị trí',
        permissions: [],
        level: 2
    },
    {
        name: 'care-duo-position-class-manager',
        text: 'Quản lý học tập',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'search-all-duo',
        text: 'Tìm kiếm tất cả bản ghi Duo',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'care-blended-tutor',
        text: 'Blended Tutor Care - Gia sư tiểu học',
        permissions: [],
        level: 1,
    },
    {
        name: 'blended-tutor-list',
        text: 'Màn hình danh sách',
        permissions: [],
        level: 2,
    },
    {
        name: 'periodically-care-bt',
        text: 'Tab chăm sóc định kì',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'care-blended-tutor-action',
        text: 'Thao tác nhanh',
        permissions: [],
        level: 4,
    },
    {
        name: 'periodically-care-bt-extend-tutor',
        text: 'Gia hạn sớm Tutor',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'periodically-care-bt-extend-duo',
        text: 'Gia hạn sớm Duo',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'periodically-care-bt-change-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'care-blended-tutor-search',
        text: 'Tìm kiếm',
        permissions: [],
        level: 4,
    },
    {
        name: 'periodically-care-bt-download',
        text: 'Download',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'extend-tutor-bt',
        text: 'Tab gia hạn Tutor',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'extend-tutor-bt-ext',
        text: 'Mốc Gia hạn',
        permissions: ['read'],
        level: 4,
    },
    {
        name: 'extend-tutor-bt-trans',
        text: 'Mốc Chuyển sale',
        permissions: ['read'],
        level: 4,
    },
    {
        name: 'extend-tutor-bt-action',
        text: 'Thao tác nhanh',
        permissions: [],
        level: 4,
    },
    {
        name: 'extend-tutor-bt-change-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'extend-tutor-bt-search',
        text: 'Tìm kiếm',
        permissions: [],
        level: 4,
    },
    {
        name: 'extend-tutor-bt-download',
        text: 'Download',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'extend-duo-bt',
        text: 'Tab gia hạn Duo',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'extend-duo-bt-action',
        text: 'Thao tác nhanh',
        permissions: [],
        level: 4,
    },
    {
        name: 'extend-duo-bt-early-extend',
        text: 'Gia hạn sớm',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'extend-duo-bt-change-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'extend-duo-bt-search',
        text: 'Tìm kiếm',
        permissions: [],
        level: 4,
    },
    {
        name: 'extend-duo-bt-download',
        text: 'Download',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'special-student-care-tab',
        text: 'Tab chăm sóc đặc biệt',
        permissions: [],
        level: 3,
    },
    {
        name: 'special-care-student',
        text: 'Học sinh chăm sóc đặc biệt',
        permissions: ['read', 'view_all'],
        level: 4,
    },
    {
        name: 'blended-tutor-task',
        text: 'Tab công việc',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'create-task-blended',
        text: 'Tạo/sửa công việc',
        permissions: ['read', 'create', 'update'],
        level: 4,
    },
    {
        name: 'blended-tutor-student',
        text: 'Thông tin chi tiết học viên',
        permissions: [],
        level: 2,
    },
    {
        name: 'on-leave-and-reserve-bt',
        text: 'Bảo lưu, nghỉ phép, đi học lại',
        permissions: ['read', 'create'],
        level: 3
    },
    {
        name: 'blended-tutor-student-detail',
        text: 'Thông tin học viên',
        permissions: ['read', 'update'],
        level: 3,
    },
    {
        name: 'move-sale-bl',
        text: 'Chuyển sale',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'search-all-blended-tutor',
        text: 'Tìm kiếm tất cả bản ghi blended',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'blended-tutor-change-teacher',
        text: 'Chuyển quản lý lớp',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'blended-tutor-change-teacher-limitation',
        text: 'Chuyển quản lý lớp GIỚI HẠN',
        permissions: ['read'],
        level: 2,
    },
    {
        name: '',
        text: 'Blended Tutor Care - Gia sư THCS',
        permissions: [],
        level: 1,
    },
    {
        name: '',
        text: 'Màn hình danh sách',
        permissions: [],
        level: 2,
    },
    {
        name: 'periodically-care-bt-secondary',
        text: 'Tab chăm sóc định kì',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'care-blended-tutor-secondary-action',
        text: 'Thao tác nhanh',
        permissions: [],
        level: 4,
    },
    {
        name: 'periodically-care-bt-secondary-extend-tutor',
        text: 'Gia hạn sớm Tutor',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'periodically-care-bt-secondary-extend-duo',
        text: 'Gia hạn sớm Duo',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'periodically-care-bt-secondary-change-teacher',
        text: 'Chuyển quản lý lớp',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'periodically-care-bt-secondary-change-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'care-blended-tutor-secondary-search',
        text: 'Tìm kiếm',
        permissions: [],
        level: 4,
    },
    {
        name: 'periodically-care-bt-secondary-download',
        text: 'Download',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'extend-tutor-bt-secondary',
        text: 'Tab gia hạn Tutor',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'extend-tutor-bt-secondary-ext',
        text: 'Mốc Gia hạn',
        permissions: ['read'],
        level: 4,
    },
    {
        name: 'extend-tutor-bt-secondary-trans',
        text: 'Mốc Chuyển sale',
        permissions: ['read'],
        level: 4,
    },
    {
        name: '',
        text: 'Thao tác nhanh',
        permissions: [],
        level: 4,
    },
    {
        name: 'extend-tutor-bt-secondary-change-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'extend-tutor-bt-secondary-change-teacher',
        text: 'Chuyển quản lý lớp',
        permissions: ['read'],
        level: 5,
    },
    {
        name: '',
        text: 'Tìm kiếm',
        permissions: [],
        level: 4,
    },
    {
        name: 'extend-tutor-bt-secondary-download',
        text: 'Download',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'extend-duo-bt-secondary',
        text: 'Tab gia hạn Duo',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'extend-duo-bt-secondary-action',
        text: 'Thao tác nhanh',
        permissions: [],
        level: 4,
    },
    {
        name: 'extend-duo-bt-secondary-early-extend',
        text: 'Gia hạn sớm',
        permissions: ['read'],
        level: 5,
    },
    {
        name: 'extend-duo-bt-secondary-change-sale',
        text: 'Chuyển sale gia hạn',
        permissions: ['read'],
        level: 5,
    },
    {
        name: '',
        text: 'Tìm kiếm',
        permissions: [],
        level: 4,
    },
    {
        name: 'extend-duo-bt-secondary-download',
        text: 'Download',
        permissions: ['read'],
        level: 5,
    },
    {
        name: '',
        text: 'Tab chăm sóc đặc biệt',
        permissions: [],
        level: 3,
    },
    {
        name: 'special-care-student-secondary',
        text: 'Học sinh chăm sóc đặc biệt',
        permissions: ['read', 'view_all'],
        level: 4,
    },
    {
        name: 'blended-tutor-secondary-task',
        text: 'Tab công việc',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'create-task-blended-secondary',
        text: 'Tạo/sửa công việc',
        permissions: ['read', 'create', 'update'],
        level: 4,
    },
    {
        name: 'blended-tutor-secondary-student',
        text: 'Thông tin chi tiết học viên',
        permissions: [],
        level: 2,
    },
    {
        name: 'on-leave-and-reserve-bt-secondary',
        text: 'Bảo lưu, nghỉ phép, đi học lại',
        permissions: ['read', 'create'],
        level: 3
    },
    {
        name: 'blended-tutor-secondary-student-detail',
        text: 'Thông tin học viên',
        permissions: ['read', 'update'],
        level: 3,
    },
    {
        name: 'move-sale-bl-secondary',
        text: 'Chuyển sale',
        permissions: ['read'],
        level: 3,
    },
    {
        name: 'search-all-blended-secondary-tutor',
        text: 'Tìm kiếm tất cả bản ghi blended',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'care-ieltsy',
        text: 'CUSTOMER CARE STATION',
        permissions: [],
        level: 1,
    },
    {
        name: 'tutor-homeroom-teacher-ieltsy',
        text: 'Quản lý lớp',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'care-sale-ieltsy',
        text: 'Sale gia hạn',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'care-tutor-list-ieltsy',
        text: 'Màn danh sách',
        permissions: [],
        level: 2
    },
    {
        name: 'c0-tab-ieltsy',
        text: 'C0',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'periodic-tab-ieltsy',
        text: 'Tab chăm sóc định kỳ',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'extends-tab-ieltsy',
        text: 'Gia hạn',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'move-sale-tab-ieltsy',
        text: 'Chuyển sale',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'all-tab-ieltsy',
        text: 'Tất cả',
        permissions: ['read', 'view_all'],
        level: 3,
    },
    {
        name: 'student-detail-ieltsy',
        text: 'Thông tin chi tiết học viên',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'change-homeroom-teacher-ieltsy',
        text: 'Chuyển quản lý lớp',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'on-leave-and-reserve-ieltsy',
        text: 'Nghỉ phép/Bảo lưu/Đi học lại',
        permissions: ['read', 'create'],
        level: 3
    },
    {
        name: 'care-call-ieltsy',
        text: 'Cấu hình cuộc gọi ieltsy',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'search-all-station',
        text: 'Tìm kiếm tất cả bản ghi station',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'care-ticket',
        text: 'Ticket - Customer Care',
        permissions: [],
        level: 1,
    },
    {
        name: 'care-submit-ticket',
        text: 'Gửi hỗ trợ',
        permissions: ['read', 'create'],
        level: 2,
    },
    {
        name: 'care-ticket-list',
        text: 'Danh sách',
        permissions: ['read'],
        level: 2,
    },
    {
        name: 'sort',
        text: 'XẾP LỚP GIA SƯ',
        permissions: [],
        level: 1,
    },
    {
        name: 'sort-class',
        text: 'Xếp lớp gia sư',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'class-manage',
        text: 'Quản lý lớp học',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'class-manage-lesson',
        text: 'Sửa giáo viên buổi học gia sư',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'student-manage',
        text: 'Quản lý học viên',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'confirm-class-schedule',
        text: 'Xác nhận lịch học',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'sort-case',
        text: 'Ca học gia sư',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 2
    },
    {
        name: 'tutor-class-change-session',
        text: 'Sửa buổi học gia sư',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'sort-ieltsy',
        text: 'XẾP LỚP IELTSY',
        permissions: [],
        level: 1,
    },
    {
        name: 'sort-class-ieltsy',
        text: 'Xếp lớp ieltsy',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'class-manage-ieltsy',
        text: 'Quản lý lớp học',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'class-manage-lesson-ieltsy',
        text: 'Sửa giáo viên buổi học station',
        permissions: ['read'],
        level: 3
    },
    {
        name: 'student-manage-ieltsy',
        text: 'Quản lý học viên',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'sort-case-ieltsy',
        text: 'Ca học ieltsy',
        permissions: ['read', 'update', 'create', 'delete'],
        level: 2
    },
    {
        name: 'tutor-class-change-session-ieltsy',
        text: 'Sửa buổi học ieltsy',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'school-manage-ieltsy',
        text: 'Quản lý trường học',
        permissions: ['read', 'update', 'create'],
        level: 2
    },
    {
        name: 'operate-erp',
        text: 'VẬN HÀNH ERP',
        permissions: [],
        level: 1,
    },
    {
        name: 'ticket-manager-sorter',
        text: 'Quản lý ticket',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'quota-on-leave',
        text: 'Cấu hình Quota nghỉ phép',
        permissions: ['read', 'update'],
        level: 2
    },
    {
        name: 'account-thr',
        text: 'Quản lý tài khoản classin',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'transfer-fee',
        text: 'Chuyển phí',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'holiday',
        text: 'Khai báo nghỉ lễ',
        permissions: ['read', 'create', 'update'],
        level: 2
    },
    {
        name: 'program-title',
        text: 'Chương trình',
        permissions: [],
        level: 2
    },
    {
        name: 'curriculum',
        text: 'Danh sách KCT',
        permissions: ['read', 'create', 'update'],
        level: 3,
    },
    {
        name: 'study-route',
        text: 'Lộ trình',
        permissions: ['read', 'create', 'delete'],
        level: 3,
    },
    {
        name: 'program',
        text: 'Chương trình',
        permissions: ['read', 'create', 'update'],
        level: 3,
    },
    {
        name: 'component-manage',
        text: 'Quản lý thành phần',
        permissions: ['read', 'create', 'update'],
        level: 3,
    },
    {
        name: 'skill-manage',
        text: 'Quản lý kỹ năng',
        permissions: ['read', 'create', 'update'],
        level: 3,
    },
    {
        name: 'classin-document',
        text: 'Học liệu Classin',
        permissions: ['read', 'create', 'update', 'delete', 'download'],
        level: 3,
    },
    // IELTSY-1664
    {
        name: 'device-manage',
        text: 'Danh sách thiết bị',
        permissions: ['read', 'create', 'update'],
        level: 2
    },
    {
        name: 'zalo-cloud',
        text: 'ZALO CLOUD',
        permissions: [],
        level: 1,
    },
    {
        name: 'call-zalo',
        text: 'Gọi thoại zalo cloud',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'reconcile',
        text: 'Đối soát đơn BANK',
        permissions: [],
        level: 1
    },
    {
        name: 'reconcile-sms',
        text: 'Đối soát SMS',
        permissions: ['read', 'download', 'view_all'],
        level: 2
    },
    {
        name: 'confirm-bank-order',
        text: 'Xác nhận',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'cancel-bank-order',
        text: 'Hủy',
        permissions: ['read', 'view_all'],
        level: 2
    },
    {
        name: 'undefined-reconcile',
        text: 'Đối soát ko xác định',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'confirmed-reconcile',
        text: 'Đối soát đã xác nhận',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'import-statement',
        text: 'Import sao kê',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'checkin',
        text: 'Điểm danh',
        permissions: [],
        level: 1
    },
    {
        name: 'checkin-manager',
        text: 'Quản lý điểm danh',
        permissions: ['read', 'update', 'view_all'],
        level: 2
    },
    {
        name: 'checkin-proactive',
        text: 'Điểm danh chủ động',
        permissions: ['read', 'update', 'view_all'],
        level: 2
    },
    {
        name: 'checkin-passive',
        text: 'Điểm danh bị động',
        permissions: ['read', 'update', 'view_all'],
        level: 2
    },
    {
        name: 'checkin-register',
        text: 'Đăng ký lịch làm việc',
        permissions: ['read', 'update', 'view_all'],
        level: 2
    },
    {
        name: 'checkin-station',
        text: 'Điểm danh Station',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'checkin-account-distribution',
        text: 'Phân bổ tài khoản',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'dot',
        text: 'Chấm chữa',
        permissions: [],
        level: 1
    },
    {
        name: 'dot-manager',
        text: 'Quản lý chấm chữa',
        permissions: ['read', 'update', 'view_all'],
        level: 2
    },
    {
        name: 'dot-teacher',
        text: 'Giáo viên chấm chữa',
        permissions: ['read' ,'update'],
        level: 2
    },
    {
        name: 'dot',
        text: 'Ticket Manager',
        permissions: [],
        level: 1
    },
    {
        name: 'ticket-manager',
        text: 'Danh sách ticket',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'transfer',
        text: 'Chuyển phí & chuyển nhượng',
        permissions: [],
        level: 1
    },
    {
        name: 'transfer-fee-v2',
        text: 'Chuyển phí & chuyển nhượng (v2)',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'exchange-payment',
        text: 'Quy đổi cọc thanh toán thêm nhiều công thức',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'edit-product-amount',
        text: 'Sửa số tiền còn lại của sản phẩm',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'convert-basic-product',
        text: 'Chuyển đổi sản phẩm cơ bản',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'advanced-product-conversion',
        text: 'Chuyển đổi sản phẩm nâng cao',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'transfer-deposit',
        text: 'Chuyển buổi cọc',
        permissions: ['read'],
        level: 2
    },
    {
        name: 'transfer-odd-lesson',
        text: 'Chuyển lẻ buổi',
        permissions: ['read'],
        level: 2
    },
];

export const actions = [{
    name: 'read',
    text: 'Truy cập',
}, {
    name: 'create',
    text: 'Thêm'
}, {
    name: 'update',
    text: 'Sửa'
}, {
    name: 'delete',
    text: 'Xóa'
}, {
    name: 'download',
    text: 'Download/Upload'
}, {
    name: 'view_all',
    text: 'Xem tất cả'
}];


export function getPermissionByAction(action) {
    return models.filter(m => m.permissions.includes(action)).map(model => `${action}-${model.name}`)
}
